import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'flex min-h-[80px] w-full rounded-xl border border-lilac-900 bg-white px-4 py-3 text-base transition-all duration-200 text-night-900 placeholder:text-night-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blueviolet disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-night-100 resize-y',
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
